import React, { createContext, useRef, useState } from "react";
import { useWasmX } from "@hooks/WasmXHook";
import { MsgExecuteContract } from "@goblinhunt/cosmes/client";

type WasmMSG = {
  msgs: MsgExecuteContract<any>[];
  memo: string;
};

type CallbackProp = {
  onSuccess?: (tx: string) => void;
  onError?: (e: Error) => void;
};

type TxModalContextProps = {
  wasmTx?: WasmMSG;
  callback?: CallbackProp;
  show: (
    messages: MsgExecuteContract<any>[],
    memo: string,
    callback?: CallbackProp
  ) => Promise<void>;
  hide: (reason?: Error) => void;
};

export const TxModalContext = createContext<TxModalContextProps>({
  show: async () => {},
  hide: () => {},
});

export const TxModalProvider: React.FC<{ children: React.ReactNode }> = ({
  children,
}) => {
  const [wasmTx, setWasmTx] = useState<WasmMSG>();
  const [callback, setCallback] = useState<CallbackProp>();
  const wasm = useWasmX();

  const show = async (
    messages: MsgExecuteContract<any>[],
    memo: string,
    callback?: CallbackProp
  ) => {
    if (!wasm)
      throw new Error("Cannot connect to blockchain, try to refresh the page");

    setCallback(callback);

    const hash = {
      msgs: messages,
      memo,
    };

    if (hash) {
      setTimeout(() => setWasmTx(hash), 100);
    }
  };

  const hide = (reason?: Error) => {
    setTimeout(() => {
      if (reason) callback?.onError?.call(null, reason);
      setWasmTx(undefined);
      setCallback(undefined);
    }, 100);
  };

  return (
    <TxModalContext.Provider
      value={{
        wasmTx,
        hide,
        show,
        callback,
      }}
    >
      {children}
    </TxModalContext.Provider>
  );
};
